export const ProjectData = [
    {
        title: "University Management Systems",
        img: "university-management-system.jpg",
        link: "https://student.kyau.edu.bd"
    },
    {
        title: "Muslim Borka Mart Ecommerce Website",
        img: "muslim-borka-mart.jpg",
        link: "https://muslimborkamart.com/"
    },

    {
        title: "Tatpolli Ecommerce Website",
        img: "tatpolli-ecommerce.jpg",
        link: "https://tatpolli.com/"
    },
    {
        title: "Resident Management System",
        img: "resident-mgt-system.jpg",
        link: ""
    },
    {
        title: "KYAMCH WEBSITE",
        img: "kyamch-website.jpg",
        link: "https://kyamch.org/"
    },
    {
        title: "Ambulance Management Systems",
        img: "ambulance-app.jpg",
        link: ""
    },
    {
        title: "Cafeteria Management System",
        img: "cafeteria.jpg",
        link: ""
    },
    {
        title: "Block Chain Technology in Healthcare",
        img: "blockchain.jpg",
        link: "https://www.youtube.com/watch?v=Qiy53TOU9qk&ab_channel=MILTONKHAN"
    },
    {
        title: "KYAU WEBSITE",
        img: "kyau-website.jpg",
        link: "https://kyau.edu.bd/"
    },
    {
        title: "KYANC WEBSITE",
        img: "kyanc-website.jpg",
        link: "https://kyanc.edu.bd/"
    },
    {
        title: "KYALSC WEBSITE",
        img: "kyalsc-website.jpg",
        link: "https://kyalsc.edu.bd/"
    },
    {
        title: "EDUSPIRE WEBSITE",
        img: "eduspire-website.jpg",
        link: "http://eduspire.com.au/"
    },
    {
        title: "Fee Management Systems",
        img: "fee-app.jpg",
        link: "https://fee.eduspire.com.au"
    },
    {
        title: "Inventory Management Systems",
        img: "inventory-app.jpg",
        link: "https://www.youtube.com/watch?v=702d1Lt0srI&ab_channel=MILTONKHAN"
    },
    {
        title: "Blood Donation Systems",
        img: "blood-donation-app.jpg",
        link: "http://blooddonation.eduspire.com.au/administration/filter-donor"
    },
];